import {queryCategories} from '@wix/ambassador-events-v1-category/http'
import {State as CategoryState, QueryCategoriesResponse} from '@wix/ambassador-events-v1-category/types'
import {createAsyncAction} from '../services/redux-toolkit'
import {reloadEvents} from './events'
import {setVeloCategoryFilter} from './velo-overrides'

export const selectCategory = createAsyncAction<void, string | null>(
  'SELECT_CATEGORY',
  async (categoryId, {dispatch}) => {
    dispatch(setVeloCategoryFilter(categoryId))
    dispatch(reloadEvents())
  },
)

export const reloadAllCategories = createAsyncAction<QueryCategoriesResponse>(
  'RELOAD_ALL_CATEGORIES',
  async (_, {extra: {flowAPI}}) => {
    const response = await flowAPI.httpClient.request(
      queryCategories({
        query: {paging: {limit: 100, offset: 0}, filter: {states: {$hasSome: [CategoryState.MANUAL]}}},
      }),
    )
    return response.data
  },
)
